<script setup>
import { computed } from 'vue';

const props = defineProps({
    min: { type: Number, default: 0 },
    current: { type: Number, default: 0 },
    levelName: { type: String, default: '' },
    variant: {
        type: String,
        default: 'view',
        validator: (v) => ['view', 'edit'].includes(v)
    }
});

const belowMin = computed(() => props.min > 0 && props.current < props.min);
</script>

<template>
    <p
        v-if="min > 0"
        class="schedule-min-slots-notice mb-0 text-sm"
        :class="belowMin ? 'schedule-min-slots-notice--warn' : 'schedule-min-slots-notice--ok'"
    >
        <span v-if="levelName" class="font-medium">{{ levelName }}</span>
        <span v-if="levelName"> · </span>
        本月
        <strong class="tabular-nums">{{ current }}</strong>
        /
        <strong class="tabular-nums">{{ min }}</strong>
        時段
        <template v-if="belowMin">
            · 未達標
            <template v-if="variant === 'edit'">，無法儲存</template>
        </template>
    </p>
</template>

<style scoped>
.schedule-min-slots-notice--ok {
    color: #475569;
}

.schedule-min-slots-notice--warn {
    color: #dc2626;
}

.schedule-min-slots-notice--warn strong {
    color: #b91c1c;
}
</style>
